define('core/utils/html/getCurrentStyle',[],function () {
    'use strict';

    // Cross-browser compatible function for getting computed styles on an element
    // Sorry for the stupid name, it's to avoid shadowing the global, native one.

    // http://www.quirksmode.org/dom/w3c_css.html
    // W3C (WebKit, Firefox, IE9+)
    if (window.getComputedStyle) {
        return function getCurrentStyle(elem, prop, _camel) {
            try {
                // We need this to both protect for the case where `elem` is not valid,
                // such as it being `document` and for the broken ShadowDOMPolyfill script.
                // See https://git.io/vrPIf for more details.
                return window.document.defaultView.getComputedStyle(elem, null).getPropertyValue(prop);
            } catch (err) {
                return null;
            }
        };
    }

    // IE < 9, Opera
    return function getCurrentStyle(elem, prop, camel) {
        return elem.currentStyle[prop] || elem.currentStyle[camel];
    };
});

